import './SankeyOverlay.css';
export var overlay = '_r8i5hk0-3-12-1';